module.exports = __webpack_public_path__ + "img/fars.40fbaf4c.jpg";